<template>
	<div>
		<div class="timeline-2">
			<div class="timeline-2_row __header">
				<div class="timeline-2_name"></div>
				
				<div class="timeline-2_score">С</div>
			</div>
			
			<div class="timeline-2_row">
				<div class="timeline-2_name" :class="isHomeWin()">{{ match.home_name }}</div>
				<div class="timeline-2_score __full" v-if="this.match.results.finalresult && this.match.results.finalresult.home === 'won'">Победа</div>
			</div>
			<div class="timeline-2_row">
				<div class="timeline-2_name" :class="isAwayWin()">{{ match.away_name }}</div>
				<div class="timeline-2_score __full" v-if="this.match.results.finalresult && this.match.results.finalresult.away === 'won'">Победа</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['match'],
		
		methods: {
			isHomeWin() {
				return {
					__bold: this.match.results.finalresult && this.match.results.finalresult.home === 'won'
				}
			},
			isAwayWin() {
				return {
					__bold: this.match.results.finalresult && this.match.results.finalresult.away === 'won'
				}
			},
		}
	}
</script>

<style scoped>

</style>